import { FreespinRecord } from "slotworks/model/gameplay/records/freespin-record";
import { SpinRecord } from "slotworks/model/gameplay/records/spin-record";
import { DataProcessorSupplement } from "slotworks/model/gameplay/supplements/data-processor-supplement";
import { slotDefinition } from "slotworks/model/slot-definition";

const H1 = [undefined, "H1", "H1_12", "H1_13", "H1_14"];
const H1FS = [undefined, "H1FS", "H1FS_12", "H1FS_13", "H1FS_14"];

export class TGRBigSymbolSupplement implements DataProcessorSupplement {
    public static FS_SWAP_ENABLED: boolean = false;
    public active: boolean = true;

    public process(record: SpinRecord) {
        if (!this.active || !record.grid) {
            return;
        }
        const h1 = TGRBigSymbolSupplement.FS_SWAP_ENABLED && record instanceof FreespinRecord ? H1FS : H1;
        record.grid.forEach((colSyms: string[], col: number) => {
            for (let row: number = 0; row < slotDefinition.matrixGrid[col]; row++) {
                if (record.grid[col][row] === "H1") {
                    if (record.grid[col][row + 1] === "H1" && colSyms[row + 2] === "H1" && colSyms[row + 3] === "H1") {
                        record.grid[col][row] = h1[4];
                        record.grid[col][row + 1] = h1[4];
                        record.grid[col][row + 2] = h1[4];
                        record.grid[col][row + 3] = h1[4];
                        break;
                    } else if (colSyms[row + 1] === "H1" && colSyms[row + 2] === "H1") {
                        record.grid[col][row] = h1[3];
                        record.grid[col][row + 1] = h1[3];
                        record.grid[col][row + 2] = h1[3];
                        break;
                    } else if (colSyms[row + 1] === "H1") {
                        record.grid[col][row] = h1[2];
                        record.grid[col][row + 1] = h1[2];
                        break;
                    }
                }
            }
        });
    }
}
